import { render, staticRenderFns } from "./index.vue?vue&type=template&id=25481156&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=25481156&prod&lang=less&scoped=true"
import style1 from "./index.vue?vue&type=style&index=1&id=25481156&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.2.37_babel-core@7.0.0-bridge.0_@babel+core@7.27._c27f08679d61a6f44f6cf7d0dd4e9fe7/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25481156",
  null
  
)

export default component.exports